import { render, staticRenderFns } from "./EditCertifyingEntityModal.vue?vue&type=template&id=01ed982a&"
import script from "./EditCertifyingEntityModal.vue?vue&type=script&lang=js&"
export * from "./EditCertifyingEntityModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports